import { render, staticRenderFns } from "./TripCategories.html?vue&type=template&id=65fe393e&external"
import script from "./TripCategories.js?vue&type=script&lang=js&external"
export * from "./TripCategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports